<template>
  <nav class="seo-breadcrumb" aria-label="Breadcrumb">
    <div class="seo-breadcrumb__inner">
      <p class="seo-breadcrumb__line">
        <template v-for="(item, i) in items">
          <router-link
            v-if="item.to && !item.current"
            :key="'a' + i"
            :to="item.to"
          >{{ item.label }}</router-link>
          <span v-else :key="'b' + i" class="seo-breadcrumb__text">{{ item.label }}</span>
          <span v-if="i < items.length - 1" :key="'s' + i" class="seo-breadcrumb__sep" aria-hidden="true">/</span>
        </template>
      </p>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'SeoBreadcrumb',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
/* 面包屑：与正文同宽，无整行背景色 */
.seo-breadcrumb {
  width: 100%;
  max-width: 100%;
  margin: 0 0 1.5rem;
  padding: 0;
  background: transparent;
  border: none;
  box-sizing: border-box;
}

.seo-breadcrumb__inner {
  max-width: 960px;
  margin: 0 auto;
  padding: 4px 24px 0;
}

.seo-breadcrumb__line {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 0;
  font-size: 0.84rem;
  line-height: 1.4;
  color: #6b7585;
}

.seo-breadcrumb__line a {
  color: #1f6b3a;
  text-decoration: none;
  font-weight: 600;
  padding: 2px 6px;
  margin: 0 -2px;
  border-radius: 6px;
  transition: color 0.18s ease, background 0.18s ease;
}

.seo-breadcrumb__line a:hover {
  color: var(--gb-wave-green, #28a745);
  background: rgba(40, 167, 69, 0.1);
  text-decoration: none;
}

.seo-breadcrumb__text {
  color: #243041;
  font-weight: 700;
  padding: 2px 4px;
}

.seo-breadcrumb__sep {
  color: #a8b4c0;
  margin: 0 6px;
  font-weight: 500;
  user-select: none;
}
</style>
